import React from "react";
import { Banknote, CalendarCheck2, Clock4, WalletCards } from "lucide-react";
import { formatCurrency, formatOvertimeHours } from "./payslipFormat";

/**
 * Tổng quan phiếu lương đã công bố, tính trên tập dữ liệu đang lọc.
 */
export default function MyPayslipMiniDashboard({ stats }) {
  const cards = [
    {
      key: "count",
      label: "Phiếu lương",
      icon: WalletCards,
      iconClass: "text-sky-600",
      value: String(stats.count || 0),
    },
    {
      key: "latest",
      label: "Thực lĩnh kỳ gần nhất",
      icon: Banknote,
      iconClass: "text-emerald-600",
      value: formatCurrency(stats.latestNet),
      hint: stats.latestLabel,
    },
    {
      key: "total",
      label: "Tổng thực lĩnh",
      icon: CalendarCheck2,
      iconClass: "text-violet-600",
      value: formatCurrency(stats.totalNet),
    },
    {
      key: "overtime",
      label: "Tổng tăng ca",
      icon: Clock4,
      iconClass: "text-amber-600",
      value: formatCurrency(stats.totalOvertime),
      hint: formatOvertimeHours(stats.totalOvertimeMinutes),
    },
  ];

  return (
    <div className="mb-4 grid grid-cols-2 gap-3 md:mb-6 md:gap-4 lg:grid-cols-4">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <div
            key={card.key}
            className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm"
          >
            <div className="mb-2 flex items-start justify-between gap-2">
              <p className="text-[11px] font-bold uppercase tracking-wider text-gray-400">
                {card.label}
              </p>
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gray-50">
                <Icon className={`h-5 w-5 ${card.iconClass}`} strokeWidth={2.25} />
              </div>
            </div>
            <p className="text-lg font-black leading-none text-gray-800 tabular-nums sm:text-xl">
              {card.value}
            </p>
            {card.hint && (
              <p className="mt-1.5 text-[11px] font-semibold text-gray-400">{card.hint}</p>
            )}
          </div>
        );
      })}
    </div>
  );
}
